// @flow
import React, { Component } from 'react';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';

import Updates from './Updates.jsx';

class UpdatesPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="Work List" />
        <ContentBox>
          This page includes all custom updates plus any automatic updates
          within the next 30 days.
        </ContentBox>
        <ContentBox title="Active">
          <Updates />
        </ContentBox>
        <ContentBox title="Archived" collapsable startCollapsed>
          <Updates archivedTable />
        </ContentBox>
      </div>
    );
  }
}

export default UpdatesPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/updates/UpdatesPage.jsx